module.exports = __webpack_public_path__ + "public/images/partner-1.7863f64b24237f0ee351670cb9b2261b.png";